import React from "react";
import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { MAIN_NAV } from "@/constants/navigation";
import { useSiteSettings, renderCopyright } from "@/hooks/useSiteSettings";

// Fed from the single navigation source; Home is excluded by design.
const NAV_LINKS = MAIN_NAV.filter((l) => l.footer);

export default function Footer() {
  const { data: site } = useSiteSettings();
  const displayName = site?.displayName || site?.companyName || "";
  const tagline     = site?.tagline || "";
  const descriptor  = site?.descriptor || "";
  const copyright   = renderCopyright(site?.copyright);

  return (
    <footer
      data-testid={FOOTER.root}
      className="border-t border-[#e5e5ea] bg-white"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7">
            <p
              data-testid="footer-company-name"
              className="text-[15px] font-semibold tracking-[-0.01em] text-[#0a0a0a]"
            >
              {displayName}
            </p>
            {tagline && (
              <p
                data-testid="footer-tagline"
                className="mt-2 text-[11px] uppercase tracking-[0.16em] text-[#6e6e73]"
              >
                {tagline}
              </p>
            )}
            {descriptor && (
              <p
                data-testid="footer-descriptor"
                className="mt-4 text-[13.5px] leading-relaxed text-[#6e6e73] max-w-md"
              >
                {descriptor}
              </p>
            )}
          </div>

          <nav
            aria-label="Footer navigation"
            className="md:col-span-5 md:justify-self-end"
          >
            <ul className="flex flex-wrap gap-x-7 gap-y-3 text-[13.5px] text-[#424245] md:justify-end">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="hover:text-[#0a0a0a]">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-8 pt-5 border-t border-[#e5e5ea] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p
            data-testid="footer-copyright"
            className="text-[12px] text-[#86868b]"
          >
            {copyright}
          </p>
          <div className="flex items-center gap-5 text-[12px] text-[#86868b]">
            <Link to="/legal/privacy" className="hover:text-[#0a0a0a]">
              Privacy
            </Link>
            <Link to="/legal/terms" className="hover:text-[#0a0a0a]">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
